import { CompanyService, Item, Listing, Move, MoveLine, WarehouseLocation } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import { orderInterface, pickDataInterface } from '../orders';

export interface orderItemInterface {
    id: number
    createdAt: string
    updatedAt: string
    orderId: number
    order?: orderInterface
    itemId: number
    item: Item | null
    listingId: number
    listing: Listing
    quantity: number
    pickedAt?: string
    pickData?: pickDataInterface
    serviceLines: Array<OrderItemServiceLine<CompanyService>>
    moves: Array<Move<MoveLine<undefined, WarehouseLocation>>>
};

export interface OrderItemServiceLine<
    S extends CompanyService | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- required for legacy compatibility; fixing would require broader type refactoring
> {
    orderItemId: number
    serviceId: number
    service: S
}

export default (axios: AxiosInstance = baseAxios): { updateOrderItemMoves: (orderId: number, orderItemId: number, locationUuid: string, quantity: number) => Promise<orderItemInterface>; } => ({
    updateOrderItemMoves: async (orderId: number, orderItemId: number, locationUuid: string, quantity: number): Promise<orderItemInterface> => {
        const response = await axios.post<{ orderItem: orderItemInterface }>(`/api/orders/${orderId}/updateItems/${orderItemId}/moves`, { locationUuid, quantity });

        return response.data.orderItem;
    },
});
